module.exports = __webpack_public_path__ + "img/img20.e138dd47.jpg";